module.exports = __webpack_public_path__ + "img/6-1end.62a47d08.png";